<template>
  <div
    class="m-app-ios__item"
    :class="banner.reverse ? 'm-app-ios__item--reverse' : ''"
  >
    <span
      class="m-app-ios__title"
      :class="banner.titleMargin ? 'm-app-ios__title--no-mb' : ''"
      v-html="banner.title"
    ></span>
    <img :src="banner.imageSrc" :alt="banner.title" />
  </div>
</template>

<script>
export default {
  name: 'BannerItem',
  props: {
    banner: {
      type: Object,
      require: true,
    },
  },
};
</script>

<style scoped lang="scss">
.m-app-ios {
  &__title {
    width: 100%;
    min-height: 55px;
    padding: 0 45px 0 47px;
    margin: 0 0 20px;
    font-size: 23px;
    font-weight: 300;
    line-height: 120%;
    color: #fff;
    white-space: normal;

    &--no-mb {
      margin-bottom: 0;
    }

    .sm-text {
      font-size: 18px;
      line-height: 120%;
    }
  }

  &__item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 675px;
    padding: 36px 0 0;
    overflow: hidden;
    background: radial-gradient(
      46.35% 147.45% at 53.65% 59.02%,
      #02b55f 0%,
      #2bca6d 100%
    );
    border-radius: 20px;

    &::before {
      position: absolute;
      bottom: -7px;
      left: 0;
      width: 217px;
      height: 486px;
      content: '';
      background: url('/pages/about-mobile-app/img/bg-ios.svg') no-repeat;
    }

    > * {
      position: relative;
      z-index: 2;
    }

    img {
      max-width: 100%;
    }

    &--reverse {
      .m-app-ios__title {
        order: 2;
        margin-top: -25px;
      }
    }
  }

  &__item,
  &__swiper-slide {
    width: 401px;
  }
}

@media (max-width: $xs) {
  .m-app-ios {
    margin-right: 0;

    &__item {
      min-height: 670px;
      padding-top: 27px;
    }

    &__title {
      min-height: 49px;
      padding: 0 27px 0 29px;
    }
  }
}

@media (max-width: $xxs) {
  .m-app-ios {
    &__item,
    &__swiper-slide {
      width: 100%;
    }
  }
}
</style>
